import { render } from "./AnnotateLabels.vue?vue&type=template&id=0c2574cd&scoped=true"
import script from "./AnnotateLabels.vue?vue&type=script&lang=js"
export * from "./AnnotateLabels.vue?vue&type=script&lang=js"

import "./AnnotateLabels.vue?vue&type=style&index=0&id=0c2574cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2574cd"]])

export default __exports__